<template>

    <m-edit1/>

    <m-Alert-1 v-bind='{...{},...{}}' :style='""' class="col-11 mx-auto mt-2 text-center" >
                <template #default>(ارسال بصورت پس کرایه می باشد)   </template>
                </m-Alert-1><m-shopping-cart-3 v-bind='{...{"EmptyCartImage":null,"instagram":false,"presenterProp":false,"addressName":false,"codeMeliProp":false,"gradeProp":false,"orientationProp":false,"schoolNameProp":false,"classNameProp":false,"birthdayProp":false,"motherJobProp":false,"fatherJobProp":false,"registerRequestProp":false,"gradeSelectProp":false,"roundTripServiceProp":false,"shiftProp":false,"showWalletChargeProp":true,"showWalletGate":true,"advanceDescriptionInputs":"","advanceDescription":false,"defaultGate":"","enableEditOrder":false,"deliveryOptionStyle":"card"},...{}}' :style='""' class="my-5" ></m-shopping-cart-3>

</template>

<script>
import mEdit1 from '@moeinmdn/miw-alpha-components/src/package/Tool/Edit/Edit1'
import {appendTagsToPage} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/Seo";

import mAlert1 from '@moeinmdn/miw-alpha-components/src/package/Alert/Alert1'; import mShoppingCart3 from '@moeinmdn/miw-alpha-components/src/package/ShoppingCart/ShoppingCart3';

export default {
    name: 'HomeView',
    components: {mEdit1, mAlert1,mShoppingCart3 },
    mounted() {
       if(this.$route.name === 'Home'){
           appendTagsToPage({}, 'home')
       }
    },
}
</script>


<style scoped>

</style>
